import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/agenda',
    name: 'consultas.index',
    component: () => import('./views/ConsultasIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'consultas.read',
      breadcrumb: 'Agenda',
    },
  },
]

export default routes
